var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#393939"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1225.000000, -86.000000) translate(1225.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 4,
    y: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M12.67 11H1.33C.594 11 0 11.448 0 12s.595 1 1.33 1h11.34c.735 0 1.33-.448 1.33-1s-.595-1-1.33-1zM33 20c-2.757 0-5 2.243-5 5s2.243 5 5 5c2.758 0 5-2.243 5-5s-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3c0 1.655-1.346 3-3 3zM15 20c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3c0 1.655-1.346 3-3 3zM36.07 2.743C35.847 2.287 35.395 2 34.9 2H28v2.697h6.091L37.66 12 40 10.788l-3.93-8.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M19 23.5H30V26H19zM10.537 23.5H5.463C4.655 23.5 4 24.06 4 24.75S4.655 26 5.463 26h5.074c.808 0 1.463-.56 1.463-1.25s-.655-1.25-1.463-1.25zM43.71 14.917l-2.723-3.46c-.262-.334-.665-.529-1.093-.529H29.836V1.366c0-.755-.62-1.366-1.384-1.366H5.384C4.62 0 4 .612 4 1.366c0 .754.62 1.366 1.384 1.366h21.684v9.562c0 .755.62 1.366 1.384 1.366h10.764l2.016 2.563v7.045h-3.83c-.764 0-1.384.612-1.384 1.366 0 .755.62 1.366 1.384 1.366h5.214C43.38 26 44 25.388 44 24.634v-8.88c0-.302-.102-.597-.29-.837z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    y: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 3,
    y: 6,
    rx: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.e1ca8d5c93cbd90300b9ef33a2d2e66c.svg";
export { ForwardRef as ReactComponent };